import { LabelType } from "components/types";
import { AnyARecord } from "dns";
import { Product, ProductTag } from "features/ProductReel/types";
import { colors } from "theme/Theme";

export const propertyTranslate = {
  quadrature: "Квадратура",
  energy_class_cooling: "Квадратура",
  energy_class_heating: "Квадратура",
  power_btu: "Квадратура",
  outbound_power_cooling: "Квадратура",
  outbound_power_heating: "Квадратура",
  en_consumption_cooling: "Квадратура",
  en_consumption_heating: "Квадратура",
  eer: "Квадратура",
  seer: "Квадратура",
  cop: "Квадратура",
  scop: "Квадратура",
  power_supply_voltage: "Квадратура",
  work_amplitude_cooling: "Квадратура",
  work_amplitude_heating: "Квадратура",
  fridge_agent: "Квадратура",
  pipe_diameter: "Квадратура",
  power_supply: "Квадратура",
  country_of_origin: "Квадратура",
  waranty: "Квадратура",
  type: "Квадратура",
  annual_power_consump_cooling: "Квадратура",
  annual_power_consump_heating: "Квадратура",
  apf: "Квадратура",
  heating_power_low_temp: "Квадратура",
};

export const getLabels = (item: any | null): ProductTag[] => {
  if (item === null) {
    return [];
  }
  let labels = item.tags ?? [];

  if (item.price_promotion) {
    const discountPercentage = (
      ((item.price - item.price_promotion) / item.price) *
      100
    ).toFixed(0);

    labels = [
      ...labels,
      {
        id: "123",
        color: colors.red,
        textColor: "white",
        title: `-${discountPercentage}%`,
        type: LabelType.Promotion,
      },
    ];
  }

  if (item.description && item.description.free_mounting) {
    labels = [
      ...labels,
      {
        id: "211",
        color: colors.blue,
        textColor: "white",
        title: `Безплатен монтаж`,
        type: LabelType.Promotion,
      },
    ];
  }

  if (item.quantity <= 0) {
    labels = [
      ...labels,
      {
        id: "212",
        color: colors.dark_gray,
        textColor: "white",
        title: `Изчерпан`,
        type: LabelType.Promotion,
      },
    ];
  }

  return labels;
};
